/**
 * SVG-фильтр подсветки недопустимой цели при перетаскивании связи (см. ModelerX6 connection drag).
 * Разметка фильтра задаётся в React: {@link InvalidConnectionTargetFilterDefs}.
 */

import {renderInvalidConnectionFilterDefs} from './invalidConnectionTargetFilterMarkup';

/** Селекторы X6-узла ArchiMate, на которые накладываем фильтр при недопустимой цели связи */
export const CONNECTION_DRAG_INVALID_FILTER_SELECTORS = [
	'body',
	'icon',
	'inner',
	'labelBody',
	'label',
];

function appendDefsFromMarkup(svg: SVGSVGElement, defsMarkup: string): void {
	const doc = new DOMParser().parseFromString(
		`<svg xmlns="http://www.w3.org/2000/svg">${defsMarkup}</svg>`,
		'image/svg+xml'
	);
	const parsed = doc.querySelector('defs');
	if (!parsed) return;
	svg.insertBefore(document.importNode(parsed, true), svg.firstChild);
}

/**
 * Гарантирует наличие `<filter>` в `<defs>` SVG графа; возвращает id для `url(#id)`.
 */
export function ensureInvalidConnectionTargetFilter(graph: {
	container?: HTMLElement | null;
	__invalidConnectionTargetFilterId?: string;
	__invalidConnectionTargetFilterDefOk?: boolean;
}): string | null {
	if (!graph) return null;
	let filterId = graph.__invalidConnectionTargetFilterId;
	if (!filterId) {
		filterId = `invalid-conn-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
		graph.__invalidConnectionTargetFilterId = filterId;
	}
	if (graph.__invalidConnectionTargetFilterDefOk) return filterId;
	const container = graph.container;
	const svg =
		container?.ownerSVGElement ||
		(container?.tagName === 'svg' ? container : null) ||
		container?.querySelector?.('svg');
	if (!svg) return filterId;
	if (svg.getElementById(filterId)) {
		graph.__invalidConnectionTargetFilterDefOk = true;
		return filterId;
	}
	const markup = renderInvalidConnectionFilterDefs(filterId);
	appendDefsFromMarkup(svg, markup);
	graph.__invalidConnectionTargetFilterDefOk = true;
	return filterId;
}
